import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const MasterDataAssumptions = () => {
	return <PlaceholderView pageType={PageType.MasterDataAssumptions} text="Assumptions" />;
};

export default MasterDataAssumptions;
